import { module } from '../app';
import moment from 'moment';
import * as _ from 'lodash';
import { constantStrings } from "../constants/constantStrings";
import * as commonConstants from "../constants/constantStrings";

const ignoredKeys = ['$$hashkey', 'desc', 'study', '_____selected', 'selectedLfromLocations', 'selectedLtoLocations'];

const unsavePromptMsg = 'You have unsaved changes. Are you sure to cancel editing without saving?';

module.factory('SelectUltrasoundTechniqueModel', [
  'Worklist', 'modalService', '$ionicLoading', 'environmentHelper',
  function (Worklist, modalService, $ionicLoading, environmentHelper) {
    class SelectUltrasoundTechniqueModel {
      constructor(ssn, sdate, checkIfStillOwningAndNotOffline) {
        this.ssn = ssn;
        this.sdate = sdate;
        this.scanResults = [];
        this.constantStrings = constantStrings;
        this.isIOSDevice = environmentHelper.isIOSDevice();
        this.currentUSRecord = null;
        this.lastSelectRecordId = null;
        this.dropdownMultiSelectText = {
          buttonDefaultText: 'Select Locations'
        };
        this.dropdownMultiSelectSetting = {
          checkBoxes: true,
          scrollableHeight: '200px',
          scrollable: true,
          displayProp: 'Desc',
          smartButtonMaxItems: 2,
          showCheckAll: false,
          showUncheckAll: false,
          smartButtonTextProvider(selectionArray) {
            return selectionArray.map((elem) => elem.Desc).join(", ");
          },
          template: '{{option.Desc}}',
          idProperty: 'Code'
        };
        this.checkIfStillOwningAndNotOffline = checkIfStillOwningAndNotOffline;
      }

      async init(modal, scope) {
        $ionicLoading.show({
          template: 'Loading ultrasound data...'
        });
        this.modalInstance = modal;
        this._scope = scope;
        let optionsPromise;
        let resultsPromise;

        try {
          optionsPromise = await this.loadUltraSoundOptions();
          resultsPromise = await this.loadUltraSoundScanResults();
        } catch (error) {
          modalService.showErrorMessage(error.data, error.status);
        }

        Promise.all([optionsPromise, resultsPromise]).then((resp) => {
          $ionicLoading.hide();
        });
      }

      async selectFirstRecordOrLastSelectedRecord() {
        if (!this.scanResults || !this.scanResults.length) {
          await this.createNew();
          return;
        }

        const firstRecord = this.lastSelectRecordId ? this.scanResults.find(x => x.Id === this.lastSelectRecordId) : this.scanResults[0];

        if (!firstRecord) {
          await this.createNew();
          return;
        }

        await this.loadUltraSoundDetail(firstRecord);
      }

      async loadUltraSoundDetail(record) {
        if (this.currentUSRecord && this.currentUSRecord.Desc == constantStrings.newUltrasoundTechniqueDescripton && record && record.Desc == constantStrings.newUltrasoundTechniqueDescripton) {
          return;
        }
        if (this.checkChanges() && !await modalService.showConfirmationAsync(unsavePromptMsg)) {
          return;
        }
        if (this.currentUSRecord && this.currentUSRecord.Desc == constantStrings.newUltrasoundTechniqueDescripton) {
          this.scanResults.shift();
        }

        if (this.createMode) {
          this.createMode = false;
        }

        this._resetSelectingState();
        this.lastSelectRecordId = record.Id;
        record.Dfrom = '' + record.Dfrom;
        record.Dto = '' + record.Dto;
        this.currentUSRecord = _.cloneDeep(record);
        this.currentUSRecord.selectedLfromLocations = [];
        this.currentUSRecord.selectedLtoLocations = [];
        // Filling up "From Location" values
        if (this.currentUSRecord.Lfrom) {
          const LfromItems = this.currentUSRecord.Lfrom.split(',');
          const LfromConfig = this.ultraSoundTechniqueOptions.UTSCAN.find(x => x.Name === constantStrings.Lfrom && x.Type === constantStrings.LIST);
          if (LfromConfig) {
            LfromItems.forEach(LfromItem => {
              const config = LfromConfig.Options.find(x => x.Code === LfromItem);
              this.currentUSRecord.selectedLfromLocations.push(config);
            });
          }
        }
        // Filling up "To Location" values
        if (this.currentUSRecord.Lto) {
          const LtoItems = this.currentUSRecord.Lto.split(',');
          const LtoConfig = this.ultraSoundTechniqueOptions.UTSCAN.find(x => x.Name === constantStrings.Lto && x.Type === constantStrings.LIST);
          if (LtoConfig) {
            LtoItems.forEach(LtoItem => {
              const config = LtoConfig.Options.find(x => x.Code === LtoItem);
              this.currentUSRecord.selectedLtoLocations.push(config);
            });
          }
        }
        record._____selected = true;
      }

      _resetSelectingState() {
        if (this.scanResults && this.scanResults.length && this.scanResults.length > 0 && this.scanResults[0].Desc == constantStrings.newUltrasoundTechniqueDescripton) {
          this.scanResults.shift();
        }
        this.scanResults.forEach(item => {
          delete item._____selected;
        });
      }

      shouldDisableCreateNewTechnique() {
        return !this.scanResults || this.scanResults.some(item => item.Desc == constantStrings.newUltrasoundTechniqueDescripton);
      }

      async createNew() {
        if (this.scanResults.some(item => item.Desc == constantStrings.newUltrasoundTechniqueDescripton)) {
          return;
        }

        if (this.checkChanges() && !await modalService.showConfirmationAsync(unsavePromptMsg)) {
          return;
        }

        this._resetSelectingState();
        this.createMode = true;

        this.currentUSRecord = {
          Study: new Date(),
          Axilla: "",
          Desc: constantStrings.newUltrasoundTechniqueDescripton,
          Dfrom: '0',
          Dto: '0',
          Lfrom: "",
          Lto: "",
          Note: "",
          Side: "",
          Technique: "",
          Type: "",
          selectedLfromLocations: [],
          selectedLtoLocations: [],
          _____selected: true
        };

        let newScanResults = [];
        newScanResults[0] = this.currentUSRecord;
        this.scanResults.forEach(item => {
          newScanResults.push(item);
        });
        this.scanResults = newScanResults;
      }

      async cancelEditing() {
        let _cancelEditingConfirmed = () => {
          this.currentUSRecord = null;
          this._resetSelectingState();
          this.createMode = false;
        };

        if (this.checkChanges() && !await modalService.showConfirmationAsync(unsavePromptMsg)) {
          return;
        }

        _cancelEditingConfirmed();
      }

      fillCurrentUSRecord() {
        this.currentUSRecord.Lfrom = "";
        this.currentUSRecord.selectedLfromLocations.forEach(item => this.currentUSRecord.Lfrom += (item.Code + ","));
        this.currentUSRecord.Lfrom = this.currentUSRecord.Lfrom.replace(/(^,)|(,$)/g, "");

        this.currentUSRecord.Lto = "";
        this.currentUSRecord.selectedLtoLocations.forEach(item => this.currentUSRecord.Lto += (item.Code + ","));
        this.currentUSRecord.Lto = this.currentUSRecord.Lto.replace(/(^,)|(,$)/g, "");
      }


      checkChanges() {
        if (!this.currentUSRecord) {
          return false;
        }

        this.fillCurrentUSRecord();

        if (this.createMode)
          return true;

        let hasChanged = false;
        let selectedRecord = (this.scanResults || []).find(x => x._____selected);

        if (!selectedRecord)
          return false;

        Object.keys(this.currentUSRecord).forEach(key => {
          if (hasChanged) {
            return;
          }
          if (ignoredKeys.some(k => k.toLowerCase() === key.toLowerCase())) {
            return;
          }
          if (this.currentUSRecord[key] !== selectedRecord[key]) {
            hasChanged = true;
          }
        });

        return hasChanged;
      }

      async save() {
        if (this.currentUSRecord.Technique == "") {
          modalService.showAlert("You must select a scan technique");
          return;
        }

        //Check if still owning
        $ionicLoading.show({template: commonConstants.processingLoaderMessage});
        const isOwnershipLost = !await this.checkIfStillOwningAndNotOffline();
        if(isOwnershipLost){
          $ionicLoading.hide();
          this.modalInstance.remove();
          return;
        }

        this.currentUSRecord.Lfrom = this.currentUSRecord.selectedLfromLocations.map(item => item.Code).join(',');
        this.currentUSRecord.Lto = this.currentUSRecord.selectedLtoLocations.map(item => item.Code).join(',');

        if (!this.createMode) {
          const selectedRecord = (this.scanResults || []).find(scan => scan._____selected);

          Object.keys(selectedRecord).forEach(key => {
            if (key === 'Note') {
              let note = this.currentUSRecord[key];
              let newline = "\\r\\n";
              note = note.replace(/(\r\n|\n|\r)/gm, newline);
              selectedRecord[key] = note;
            } else {
              selectedRecord[key] = this.currentUSRecord[key];
            }
          });
        }

        this.createMode = false;
        this.currentUSRecord = null;

        $ionicLoading.show({
          template: 'Saving...'
        });
        try {
          await Worklist.saveUltraSoundScanResults({
            SSN: this.ssn,
            SDATE: this.sdate,
            Records: this.scanResults.map(r => {
              const recordObj = {
                Id: r.Id,
                Fields: []
              };

              Object.keys(r).forEach(key => {
                if (ignoredKeys.some(k => k.toLowerCase() === key.toLowerCase())) {
                  return;
                }

                if (key === 'Note') {
                  let note = r[key];
                  let newline = "\\r\\n";
                  note = note.replace(/(\r\n|\n|\r)/gm, newline);
                  recordObj.Fields.push({
                    Name: key,
                    Value: note
                  });
                } else {
                  recordObj.Fields.push({
                    Name: key,
                    Value: r[key]
                  });
                }
              });

              return recordObj;
            })
          });
        }
        catch (error) {
          modalService.showErrorMessage(error.data, error.status);
        }
        finally {
          $ionicLoading.hide();
          await this.loadUltraSoundScanResults();
        }
      }

      async delete() {
        modalService.showConfirmation(new function () { }, 'Are you sure you want to delete this item?')
          .then(async (resp) => {
            if (resp) {
              //Check if still owning
              $ionicLoading.show({template: commonConstants.processingLoaderMessage});
              const isOwnershipLost = !await this.checkIfStillOwningAndNotOffline();
              if(isOwnershipLost){
                $ionicLoading.hide();
                this.modalInstance.remove();
                return;
              }

              this.lastSelectRecordId = null;

              $ionicLoading.show({
                template: 'Deleting...'
              });
              try {
                if (this.currentUSRecord && this.currentUSRecord.Desc == constantStrings.newUltrasoundTechniqueDescripton) {
                  this.scanResults.shift();
                } else {
                  await Worklist.deleteUltrasoundTechnique(this.currentUSRecord.Id);
                }
                this.currentUSRecord = null;
              }
              catch (error) {
                modalService.showErrorMessage(error.data, error.status);
              }
              finally {
                await this.loadUltraSoundScanResults();
                $ionicLoading.hide();
              }
            }
          });
      }

      ok() {
        this.isCancelled = false;
        this.modalInstance.remove();
      }

      async cancel() {
        if (this.checkChanges() && !await modalService.showConfirmationAsync(unsavePromptMsg)) {
          return;
        }

        this.isCancelled = true;
        this.modalInstance.remove();
      }

      setDescriptionForUltrasoundOption(options) {
        _.each(options, option => {
          option.Desc = `${ option.Desc } ${ commonConstants.CM_NAME }`;
        });
      }

      mapUltrasoundScanOptions() {
        _.each(this.ultraSoundTechniqueOptions.UTSCAN, x => {
          if (x.Name === commonConstants.DISTANCE_FROM_NAME || x.Name === commonConstants.DISTANCE_TO_NAME) {
            this.setDescriptionForUltrasoundOption(x.Options);
          }
        })
      }

      async loadUltraSoundOptions() {
        this.ultraSoundTechniqueOptions = (await Worklist.getUltraSoundScanOptions()).data;
        this.mapUltrasoundScanOptions();
      }

      async loadUltraSoundScanResults() {
        $ionicLoading.show({
          template: 'Loading...'
        });
        try {
          const response = await Worklist.getUltraSoundScanResults(this.ssn, this.sdate);
          this.scanResults = response.data.Records || [];
          await this.selectFirstRecordOrLastSelectedRecord();
        }
        catch (error) {
          console.error(error);
        }
        finally {
          $ionicLoading.hide();
        }
      }
    }

    return SelectUltrasoundTechniqueModel;
  }]);



// WEBPACK FOOTER //
// ./src/scripts/models/selectUltrasoundTechnique.js